import {
  AfterViewInit,
  Component,
  ChangeDetectionStrategy,
  Renderer2,
  ElementRef,
} from '@angular/core';
import { PmdTooltipConfig } from './tooltip.config';
import { isBs3 } from '../utils';

@Component({
  selector: 'pmd-tooltip-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '"tooltip " + "bs-tooltip-" + placement + " " + containerClass',
    '[attr.id]': 'this.id',
    role: 'tooltip',
    '[class.show]': 'pmdtooltipClass',
    //   '[class.pmd-tooltip]': '!isBs3',
  },
  template: `
    <div class="tooltip-arrow arrow"></div>
    <div class="tooltip-inner"><ng-content></ng-content></div>
  `,
  standalone: false,
})
export class PmdTooltipContainer implements AfterViewInit {
  classMap: any;
  placement: string;
  containerClass: string;
  animation: boolean;
  theme: string;
  pmdtooltipClass: boolean = false;
  id: string;

  get isBs3(): boolean {
    return isBs3();
  }

  constructor(
    config: PmdTooltipConfig,
    private _renderer: Renderer2,
    private _elementRef: ElementRef
  ) {
    Object.assign(this, config);
  }

  ngAfterViewInit(): void {
    this.classMap = { in: false, fade: false };
    this.classMap[this.placement] = true;
    this.classMap[`tooltip-${this.placement}`] = true;

    this.classMap.in = true;
    if (this.animation) {
      this.classMap.fade = true;
    }

    if (this.theme !== 'bootstrap4') {
      setTimeout(() => {
        this._elementRef.nativeElement.classList.add('pmd-tooltip');
      }, 0);
      setTimeout(() => {
        this._elementRef.nativeElement.classList.add('show');
      }, 10);
    } else {
      setTimeout(() => {
        this._elementRef.nativeElement.classList.add('show');
      }, 10);
    }

    if (this.containerClass) {
      this.classMap[this.containerClass] = true;
    }
  }
}
